import { IBookingCalendarStore } from '../index'

export default function(state: IBookingCalendarStore): IBookingCalendarStore {
  return {
    ...state,
    eventHint: {
      ...state.eventHint,
      open: false,
    },
  }
}
